import { Heading } from '@hfs/ui/components/Heading'
import { Row } from '@hfs/ui/components/Row'

export const NoMatch = () => (
  <Row align="center" justify="center">
    <Heading type="display">Oh, no. Ti sei perso?</Heading>
  </Row>
)
